/**
 * Present when the progress has completed.
 */
export const complete = 'data-complete';
/**
 * Present when the progress is in indeterminate state.
 */
export const indeterminate = 'data-indeterminate';
/**
 * Present while the progress is progressing.
 */
export const progressing = 'data-progressing';